export type EnhancedLeadTrackingFields = {
  page_source?: EnhancedLeadTrackingPageSource;
  platform: EnhancedLeadTrackingPlatform;
  page_position?: number;
  snowplow_domain_session_id?: string;
  ad_ext_id?: string;
  ad_partner_id?: string;
};

export enum EnhancedLeadTrackingPageSource {
  VDP = 'VDP_STANDARD',
  SRP = 'SRP_STANDARD',
}

export enum EnhancedLeadTrackingPlatform {
  Desktop = 'web',
  Mobile = 'mobile_web',
}

export default EnhancedLeadTrackingFields;
